import {
  withCompInfo,
  createComponentMapperModel,
} from '@wix/editor-elements-integrations';
import { SubmenuDefinition, SubmenuCarmiProps } from '../types';

export const props = withCompInfo<{}, SubmenuDefinition, SubmenuCarmiProps>()(
  [],
  (_, carmiData) => carmiData,
);

export default createComponentMapperModel({ props });
